import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cancel } from '@mui/icons-material';
import Button from '@ui-lib/components/Button';
import { useModal } from '@web-shared/hooks';
import { EBOL_STATUS } from '../../../../../api/types/EbolStatus';
import EbolActionModal from './EbolActionModal';
import { EbolActionProps } from './EbolActionModal/types';

const RejectButton = (props: EbolActionProps) => {
  const { t } = useTranslation();
  const [open, handleModal] = useModal();

  return <>
    <Button
      color="error"
      startIcon={<Cancel />}
      onClick={handleModal}
      fullWidth
    >
      {t('label_reject')}
    </Button>
    <EbolActionModal
      open={open}
      onClose={handleModal}
      status={EBOL_STATUS.REJECTED}
      {...props} />
  </>;
};

export default RejectButton;